import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EN_TRANSLATIONS } from './Translation/en';
import { ES_TRANSLATIONS } from './Translation/es';
import { FR_TRANSLATIONS } from './Translation/fr';

// ⬇️ import your language objects


type Lang = 'en' | 'es' | 'fr';

@Injectable({ providedIn: 'root' })
export class I18nService {

  private translationsMap: Record<Lang, any> = {
    en: EN_TRANSLATIONS,
    es: ES_TRANSLATIONS,
    fr: FR_TRANSLATIONS
  };

  private langSubject = new BehaviorSubject<any>(EN_TRANSLATIONS);
  translations$ = this.langSubject.asObservable();

  private currentLang: Lang = 'en';

  constructor() {
   
    this.setLanguage('en');
  }

  setLanguage(lang: Lang): void {
    this.currentLang = lang;

    this.langSubject.next(this.translationsMap[lang]);
  }

  /** Safe getter */
  t(obj: any, path: string, params?: Record<string, string | number>): string {
    let value =
      path.split('.').reduce((o, k) => o?.[k], obj) ?? path;

    if (params && typeof value === 'string') {
      Object.keys(params).forEach(key => {
        value = value.replace(`{${key}}`, String(params[key]));
      });
    }

    return value;
  }

  /** Get login URL with current language parameter */
  getLocalizedLoginUrl(baseUrl: string): string {
    const langMap: Record<Lang, string> = {
      en: 'en_US',
      es: 'es',
      fr: 'fr'
    };

    const langParam = langMap[this.currentLang];
    return `${baseUrl}?lang=${langParam}`;
  }

  /** Get current language */
  getCurrentLanguage(): Lang {
    return this.currentLang;
  }
}




// import { Injectable } from '@angular/core';
// import { BehaviorSubject } from 'rxjs';
// import { HttpClient } from '@angular/common/http';

// @Injectable({ providedIn: 'root' })
// export class I18nService {
//   public lang$ = new BehaviorSubject<any>({});

//   translations$ = this.lang$.asObservable();

//   constructor(private http: HttpClient) {
//     this.setLanguage('en'); // ✅ default
//   }

//   setLanguage(lang: 'en' | 'es' | 'fr') {
//     this.http
//       .get(`public/i18n/${lang}.json`)
//       .subscribe(data => {
//         // 🔥 FULL REPLACEMENT (NO MERGE)
//         this.lang$.next(data);
//       });
//   }

//   t(obj: any, path: string, params?: Record<string, string | number>): string {
//   let value = path.split('.').reduce((o, k) => o?.[k], obj) ?? path;

//   if (params) {
//     Object.keys(params).forEach(key => {
//       value = value.replace(`{${key}}`, String(params[key]));
//     });
//   }

//   return value;
// }
// }
